import AxiosInstance from 'src/shared/services/axios/interceptor';
import { User } from 'src/shared/models/user';
import { UserRequest } from 'src/modules/user/models/userRequest';
import { PagedResult } from '../models/pagedResult';
import { setPagingParams } from '../functions/createPagingParams';

const controllerUser = 'User';

export const getUserSettings = () => {
  const endpoint = `${controllerUser}/me`;
  return AxiosInstance.get<User>(endpoint);
};

export const getUserById = (userId) => {
  const endpoint = `${controllerUser}/${userId}`;
  return AxiosInstance.get<User>(endpoint);
};

export const getUsers = (pageIndex, pageSize, sortCol, sortDir, searchFilter) => {
  // selectionId, associationId, districtId, status, groupName, searchFilter
  let extraQuery = '';
  // extraQuery += selectionId ? `&selectionId=${selectionId}` : '';
  // extraQuery += groupName ? `&groupName=${groupName}` : '';
  extraQuery += searchFilter ? `&filter=${searchFilter}` : '';
  // extraQuery += associationId ? `&associationId=${associationId}` : '';
  // extraQuery += districtId ? `&districtId=${districtId}` : '';
  // if (status && status.length > 0) {
  //   status.forEach((x) => {
  //     extraQuery += `&status=${x}`;
  //   });
  // }
  const endpoint = `${controllerUser}/?${setPagingParams({
    pageIndex,
    pageSize,
    sortCol,
    sortDir,
  })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<User>>(endpoint);
};

export const createUser = (data: UserRequest) => {
  return AxiosInstance.post<UserRequest>(controllerUser, data);
};

export const updateUser = (data: UserRequest) => {
  return AxiosInstance.put<UserRequest>(controllerUser, data);
};

export const deleteUserById = (userId) => {
  return AxiosInstance.delete<User>(`${controllerUser}/${userId}`);
};

// Kundinställning för användarvillkor (sys_settings, kategori "USER").
const controllerUserTerms = 'UserTerms';

export type UserTermsSettings = {
  requireTermsAcceptance: boolean;
  termsVersion: string;
  termsText: string;
};

export const getUserTermsSettings = () => {
  return AxiosInstance.get<UserTermsSettings>(`${controllerUserTerms}/Settings`);
};

export const updateUserTermsSettings = (data: UserTermsSettings) => {
  return AxiosInstance.put(`${controllerUserTerms}/Settings`, data);
};

// Gate-status för inloggad användare.
export type UserTermsStatus = {
  required: boolean;
  accepted: boolean;
};

// skipErrorToast: bakgrundskoll vid inloggning – gaten failar öppet och ska inte nagga med toaster.
export const getUserTermsStatus = () => {
  return AxiosInstance.get<UserTermsStatus>(`${controllerUserTerms}/Status`, { skipErrorToast: true });
};

// Engångstoken för BankID-signering av villkoren i FS.Forms.
export const createUserTermsSignSession = () => {
  return AxiosInstance.post<{ token: string }>(`${controllerUserTerms}/CreateSignSession`, null, { skipErrorToast: true });
};
